<div class="modal-wrapper">
    <form
    [formGroup]='addNewOrganizationForm'
    (submit)='onSubmit()'
    novalidate
  >
	<div class="modal-header">
    <h1 class="modal-title">New organization</h1> 
	  <i class="ic-close icon-size-32" (click)="activeModal.dismiss('Cross click')"></i>
	</div>
	<div class="modal-body">
    <div class="form-container">
        <div class="form-group">
            <label for='name' class="input-title" [class.text-error]="submitted && newOrganizationForm.name.invalid">Name</label>
            <input 
              name="name"
              required
              class="form-control"
              type="text"
              formControlName="name"
              placeholder="Insert name"
              [class.is-invalid]="submitted && newOrganizationForm.name.invalid"
              [class.is-valid]="submitted && newOrganizationForm.name.valid"
            >
            <small class="invalid-feedback text-error">Name is mandatory. Please fill the field!</small>
          </div>
        </div>
	</div>
	<div class="modal-footer">
		<button type="button" class="btn btn-outline-dark" (click)="onClose()">Cancel</button>
		<button class="btn btn-error"  [disabled]='newOrganizationForm.name.invalid' type="submit">Create</button>
	</div>
    </form>
</div>